import { environment } from 'src/environments/environment';

const api_url = environment.api_url;

export const apis = {
  login: api_url + 'login',
  get_counters_vendedor: api_url + 'counters',
  activaciones_vendedor: api_url + 'activaciones_vendedor',
  inventario_vendedor: api_url + 'inventario_vendedor',
  inventario_subdistribuidores: api_url + 'inventario_subdistribuidores',
  activaciones_subdistribuidor: api_url + 'activaciones_subdistribuidor',
  sims_caducados: api_url + 'sims_caducados',
  sims_por_caducar: api_url + 'sims_por_caducar',
  detalle_reportes: api_url + 'detalle_reportes',
  get_semaforo_data: api_url + 'get_semaforo_data',
  // Perfil endpoints - Nuevos endpoints del backend Terraform
  get_profile: api_url + 'profile',
  update_profile: api_url + 'profile/update',
  upload_avatar: api_url + 'profile/upload-avatar',
  get_user_stats: api_url + 'profile/stats',
  // Admin endpoints
  get_csv_upload_url: api_url + 'get_csv_upload_url',
  upload_csv: api_url + 'upload_csv',
  calcular_comisiones: api_url + 'calcular_comisiones',
  list_s3_files: api_url + 'list_s3_files',
  download_puntos_cp: api_url + 'download_puntos_cp',
  // Usuarios endpoints
  list_users: api_url + 'users/list',
  create_user: api_url + 'users/create',
  update_user: api_url + 'users/update',
  // Vendedores endpoints (temporalmente usando URL directa hasta que CloudFront actualice cache)
  list_vendedores: 'https://g9hnpp31n2.execute-api.us-east-1.amazonaws.com/dev/vendedores',
  // Notificaciones endpoints
  register_device_token: api_url + 'register-device-token',
  get_notifications: api_url + 'get-notifications',
  mark_notification_read: api_url + 'mark-notification-read',
  delete_notification: api_url + 'delete-notification',
  create_campaign: api_url + 'create-campaign',
  update_campaign: api_url + 'update-campaign',
  list_campaigns: api_url + 'list-campaigns',
  send_notifications: api_url + 'send-notifications',
};
